module.exports = __webpack_public_path__ + "media/images/ligweb_default_img-0d704580496e5a3f460c6f0d4066a0a8.jpg";